import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { string, func } from 'prop-types';
import { get } from 'lodash-es';
import { urlVideoIdSelector } from 'pages/channel.page/index';
import { getVideoSelector } from 'components/video-box/selectors';
import { MobilePage } from 'pages/mobile-page';
import {
  getVideoAttachmentsAvailableSelector,
  getVideoAttachmentsTotalNumberSelector,
} from 'components/video-box/video-attachments/selector';
import { videoAttachmentsFetchRequestAction } from 'components/video-box/video-attachments/actions';
import { videoBoxRequestAction } from 'components/video-box/actions';
import { VideoAttachments } from 'components/video-box/video-attachments';
import { translateForCustomer } from 'utils/i18n';
import { getCustomerSelector } from 'common/selectors';

class AttachmentsPage extends React.Component {
  componentDidMount() {
    this.props.preloadData();
  }

  render() {
    const { headerTitle, contentTitle, goBack } = this.props;

    return (
      <MobilePage headerTitle={headerTitle} goBack={goBack}>
        <span className="ct-attachments-page__content-title">{contentTitle}</span>
        <VideoAttachments />
      </MobilePage>
    );
  }
}

AttachmentsPage.propTypes = {
  headerTitle: string,
  goBack: func.isRequired,
  contentTitle: string.isRequired,
  preloadData: func.isRequired,
};

const mapStateToProps = (state, props) => ({
  videoId: urlVideoIdSelector(state, props.match),
  videoTitle: get(getVideoSelector(state), 'title'),
  withAttachments: getVideoAttachmentsAvailableSelector(state),
  attachmentsTotal: getVideoAttachmentsTotalNumberSelector(state),
  customer: getCustomerSelector(state) || {},
});

const mapDispatchToProps = (dispatch) => ({
  loadVideoAttachments: (videoId) => dispatch(videoAttachmentsFetchRequestAction(videoId)),
  loadVideoBox: (videoId) => dispatch(videoBoxRequestAction(videoId)),
});

const mergeProps = (stateProps, dispatchProps, props) => ({
  preloadData: () => {
    dispatchProps.loadVideoBox(stateProps.videoId);
    dispatchProps.loadVideoAttachments(stateProps.videoId);
  },
  goBack: () => {
    props.history.go(-1);
  },
  headerTitle: stateProps.videoTitle,
  contentTitle: !stateProps.attachmentsTotal
    ? ''
    : translateForCustomer('attachments.total', stateProps.customer, { total: stateProps.attachmentsTotal }),
});

export const AttachmentsPageDecorated = compose(
  withRouter,
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps, mergeProps)
)(AttachmentsPage);
